import BaseApi from '../base/base'
import AnswerForm from '../../forms/answer'
import Answer from '../../models/answer'

export default class AnswerApi extends BaseApi {
  constructor() {
    super()
    this.path = '/answers'
  }

  async create(answerForm: AnswerForm) {
    this.path = '/answers'
    const response = await this.postFormData(answerForm.toFormData())
    return new Answer(response.data)
  }

  async update(id: number, answerForm: AnswerForm) {
    this.path = `/answers/${id}`
    const response = await this.putFormData(answerForm.toFormData())
    return new Answer(response.data)
  }

  async delete(id: number) {
    this.path = `/answers/${id}`
    await this.deleteRequest()
    return true
  }
}
